export default "__VITE_ASSET__ed3995d1__"